import man from './man';
import interviewer from './interviewer';
import paul from './paul';

export default {
  man,
  interviewer,
  paul
};
